export const LogoMark = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="18" fill="#111511" />
    <path d="M20 46V18M20 33l14-15M25 28l11 18" stroke="#FAFAF7" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <path d="M38 30c0-7 5-12 12-12 0 7-5 12-12 12z" fill="#9CC26A" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="w-10 h-10 shrink-0" />
    <span className="leading-none">
      <span className={`block font-head text-[19px] font-semibold tracking-tight ${light ? "text-white" : "text-[#111511]"}`}>K&amp;A</span>
      <span className={`block text-[11px] font-medium uppercase tracking-[0.24em] mt-1 ${light ? "text-[#C9CEC6]" : "text-[#5B615A]"}`}>Gartenservice</span>
    </span>
  </span>
);
